import { render, staticRenderFns } from "./ListApproved.vue?vue&type=template&id=c1b7d6d8&scoped=true"
import script from "./ListApproved.vue?vue&type=script&lang=js"
export * from "./ListApproved.vue?vue&type=script&lang=js"
import style0 from "./ListApproved.vue?vue&type=style&index=0&id=c1b7d6d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1b7d6d8",
  null
  
)

export default component.exports